import { Container, Row, Col, Button } from 'react-bootstrap';
import { Clock, MapPin, Users } from 'lucide-react';

function RegistrationMethods() {

    const methods = [
        {
            icon: Clock,
            title: "Deklarowanie czasu pracy",
            forWhom: "Dla małych, zaufanych zespołów i pracy projektowej",
            description: "Pracownicy wpisują liczbę przepracowanych godzin oraz projekt. Najprostszy sposób na zastąpienie papierowych list i szybkie rozliczenia."
        },
        {
            icon: MapPin,
            title: "Start–Stop + GPS",
            forWhom: "Dla firm wymagających pełnej kontroli obecności",
            description: "Pracownik rozpoczyna i kończy pracę jednym kliknięciem, a system potwierdza jego lokalizację. Idealne dla agencji i firm z rozproszonym personelem."
        },
        {
            icon: Users,
            title: "Brygadzista rejestruje czas ekipy",
            forWhom: "Dla firm terenowych i zespołów pracujących w brygadach",
            description: "Lider zespołu wprowadza czas pracy całej brygady na koniec dnia. Minimalna liczba kliknięć, idealne przy pracownikach bez smartfonów."
        }
    ];

    return (
        <Container fluid style={{ backgroundColor: '#ffffff', padding: '80px 20px' }}>
            <Container>
                <Row className='mb-5'>
                    <Col className='text-center'>
                        <h2
                            style={{
                                fontSize: "2.5rem",
                                fontWeight: "bold",
                                color: "#1f2937",
                                marginBottom: "20px",
                                textAlign: "center",
                            }}
                        >
                            Różne sposoby rejestracji czasu pracy
                        </h2>
                        <p
                            style={{
                                fontSize: "1.1rem",
                                color: "#6b7280",
                                marginBottom: "40px",
                                textAlign: "center",
                                maxWidth: "800px",
                                margin: "0 auto 40px auto",
                                lineHeight: "1.6",
                            }}
                        >
                            Firmy różnią się sposobem pracy, poziomem zaufania i potrzebą kontroli. W eGodzinach możesz wybrać metodę rejestracji czasu, która sprawdzi się najlepiej.
                        </p>
                    </Col>
                </Row>

                <Row className='justify-content-center'>
                    {methods.map((method, index) => {
                        const IconComponent = method.icon;
                        return (
                            <Col key={index} xs={12} md={6} lg={4} className='mb-4'>
                                <div className='registration-method-card'>
                                    <div className='method-icon-wrapper'>
                                        <IconComponent
                                            size={40}
                                            strokeWidth={1.5}
                                            style={{ color: '#407EF9' }}
                                        />
                                    </div>

                                    <h4 style={{
                                        fontSize: '1.375rem',
                                        fontWeight: '600',
                                        color: '#262A33',
                                        marginBottom: '12px',
                                        marginTop: '20px'
                                    }}>
                                        {method.title}
                                    </h4>

                                    <p style={{
                                        fontSize: '0.9rem',
                                        fontWeight: '600',
                                        color: '#407EF9',
                                        marginBottom: '16px'
                                    }}>
                                        {method.forWhom}
                                    </p>

                                    <p style={{
                                        fontSize: '1rem',
                                        color: '#6B7280',
                                        lineHeight: '1.6',
                                        marginBottom: '0'
                                    }}>
                                        {method.description}
                                    </p>
                                </div>
                            </Col>
                        );
                    })}
                </Row>

                <Row className='mt-4 pt-2'>
                    <Col className='text-center'>
                        <p style={{
                            fontSize: '0.95rem',
                            color: '#262A33',
                            marginBottom: '16px',
                            fontWeight: '500'
                        }}>
                            Nie jesteś pewien, która metoda sprawdzi się najlepiej?<br />
                            Zdzwońmy się. Doradzimy na podstawie doświadczeń z podobnych firm.
                        </p>
                        <Button 
                            onClick={() => window.open('https://calendly.com/krzysztof-warda-egodziny/30min', '_blank')}
                            className="button-default"
                            style={{
                                backgroundColor: '#407EF9',
                                color: 'white',
                                border: '2px solid #407EF9',
                                borderRadius: '11px',
                                padding: '13.2px 20px',
                                fontSize: '1rem',
                                fontWeight: '600',
                                transition: 'all 0.3s ease'
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.transform = 'scale(1.05)';
                                e.target.style.backgroundColor = '#407EF9';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.transform = 'scale(1)';
                                e.target.style.backgroundColor = '#407EF9';
                            }}
                        >
                            Umów demo
                        </Button>
                    </Col>
                </Row>
            </Container>
        </Container>
    );
}

export default RegistrationMethods;